<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-scroll h-wrapper-680">
        <div class="h-dialogContainer">
			<div class="form-group h-col-inputBox">
				<div class="e-float-input">
					<div class="h-inputLit">{{$t('Pm.emergencyAlarm')}}</div>
					<div class="col-md-6"><input  disabled :value="colorCritical"/></div>
          <ejs-colorpicker :value="colorCritical" :change="criticalInputClick"></ejs-colorpicker>
				</div>
			</div>
      <div class="form-group h-col-inputBox">
				<div class="e-float-input">
					<div class="h-inputLit">{{$t('System.major')}}</div>
					<div class="col-md-6"><input disabled :value="colorMajor" /></div>
          <ejs-colorpicker :value="colorMajor" :change="majorInputClick"></ejs-colorpicker>
				</div>
			</div>
			<div class="form-group h-col-inputBox">
				<div class="e-float-input">
					<div class="h-inputLit">{{$t('System.minor')}}</div>
					<div class="col-md-6"><input disabled :value="colorMinor" /></div>
          <ejs-colorpicker :value="colorMinor" :change="minorInputClick"></ejs-colorpicker>
				</div>
			</div>
			<div class="form-group h-col-inputBox">
				<div class="e-float-input">
					<div class="h-inputLit">{{$t('System.warn')}}</div>
					<div class="col-md-6"><input disabled :value="colorWarn" /></div>
          <ejs-colorpicker :value="colorWarn" :change="warnInputClick"></ejs-colorpicker>
				</div>
			</div>
			              

      <div class="h-bottom-btnBox h-system-btnBox">
        <div class="row">
          <div class="col-md-6 h-col-inputBox">
            <ejs-button cssClass="e-small h-system-personalbtn" :isPrimary="true" @click.native="resetAlarmColor">{{$t('System.reset')}}</ejs-button>
				    <ejs-button cssClass="e-small h-system-personalbtn" :isPrimary="true" @click.native="saveAlarmColor">{{$t('System.save')}}</ejs-button>              
			    </div>
        </div>
      </div>
      <div class="b-t"></div>
      <div class="form-group h-col-inputBox"></div>
      <div class="form-group h-col-inputBox">
        <div class="e-float-input">
          <div class="h-inputLit">{{$t('System.sound')}}</div>
            <div class="h-toolbarBg">
              <ejs-button
                cssClass="e-small"
                :isPrimary="true"
                id="upButton"
                allowedExtensions=".png"
                @click.native="upFile"
              >{{$t('System.selectFile')}}</ejs-button>
            </div>
            <div class="h-inputLit h-system-line-height-custom">{{$t('System.soundTip')}}</div>
          </div>
        </div>
        <div class="h-system-hide-upload">
          <ejs-uploader
            ref="file"
            name="file"
            id="fileSound"
            autoUpload="false"
            :selected="onFileSelect"
            allowedExtensions=".mp3"
            :dropArea="dropElement"
            :multiple="false"
          ></ejs-uploader>
        </div>
        <div id="dropArea" style="display:none;padding-left:50px">
          <img id="imgShow" src width="83px" height="35px" />
          <ejs-button
            id="removeIcon"
            iconCss="icon hero-icon hero-icon-remove-small"
            cssClass="e-small e-round"
            :isPrimary="true"
            @click.native="removeImage"
          ></ejs-button>
        </div>


      </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import { EventBus } from '../../plugins/eventBus';
import mixin from '../../mixin/mixin';

export default {
  name: "AlarmPresent",
  mixins: [mixin],
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.systemSet')}/${this.$t('System.alarmPresent')}` },
      dropElement: ".control-fluid",
	    arr: [],
      colorCritical: '',
      colorMajor:'',
      colorMinor:'',
      colorWarn:'',
      styleColorVar:{},
    };
  },
  components: {
    BasicLayout
  },
  methods: {
    // 颜色输入框点击事件处理
		criticalInputClick (args) {
			this.colorCritical = args.currentValue.hex;
		},
		majorInputClick(args){
      this.colorMajor = args.currentValue.hex;
		},
		minorInputClick(args){
			this.colorMinor = args.currentValue.hex;
		},
		warnInputClick(args){
			this.colorWarn = args.currentValue.hex;
		},
		// 颜色值改变事件处理
		criticalColorValueChange (val) {
			this.colorCritical = val.hex;
		},
		majorColorValueChange(val){
			this.colorMajor = val.hex;
		},
		minorColorValueChange(val){
			this.colorMinor = val.hex;
		},
		warnColorValueChange(val){
			this.colorWarn = val.hex;
		},
    resetAlarmColor() {
      // console.log("this.arr",this.arr)
      this.arr.forEach((item,i) => {
        let itemcolor = item.colorcode;
        
        switch(item.levelid){
          case 0:
            this.colorCritical = itemcolor;
            break;
          case 1:
            this.colorMajor = itemcolor;
            break;
          case 2:
            this.colorMinor = itemcolor;
          case 3:
            this.colorWarn = itemcolor;
          default:
            break;
        }
      })
	  },
    queryAlarmLevel(){
      this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
      this.colorCritical = this.styleColorVar['--colorCritical'];
      this.colorMajor = this.styleColorVar['--colorMajor'];
      this.colorMinor = this.styleColorVar['--colorMinor'];
      this.colorWarn = this.styleColorVar['--colorWarn'];
      this.arr.push({"levelid":0,"colorcode":this.colorCritical});
      this.arr.push({"levelid":1,"colorcode":this.colorMajor});
      this.arr.push({"levelid":2,"colorcode":this.colorMinor});
      this.arr.push({"levelid":3,"colorcode":this.colorWarn});
    },
    saveAlarmColor() {
      const url = "/lte/ems/fm/alarmpresent/saveAlarmColor";
      let formData = {"0":this.colorCritical,"1":this.colorMajor,"2":this.colorMinor,"3":this.colorWarn};
      this.axios.post(url, formData).then(response => {
        if(response.status == 200 && response.data){
          let styleColorVar = {
            "--colorCritical": this.colorCritical,
            "--colorMajor": this.colorMajor,
            "--colorMinor": this.colorMinor,
            "--colorWarn": this.colorWarn
          };
          localStorage.setItem('styleColorVar', JSON.stringify(styleColorVar));
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Common.tips.success')}`});
          this.arr.push({"levelid":0,"colorcode":this.colorCritical});
          this.arr.push({"levelid":1,"colorcode":this.colorMajor});
          this.arr.push({"levelid":2,"colorcode":this.colorMinor});
          this.arr.push({"levelid":3,"colorcode":this.colorWarn});
        }else{
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('Common.tips.failure')}`});
        }
      });
    },
    onFileSelect(args) {
      const file = args.filesData[0];
      if (file.size > 1024 * 1024 * 2) {
        this.$refs.file.clearAll();
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('System.uploadTipsSize')}`});
        return null;
      }
      // if(file.type != 'png' && file.type != 'PNG'){
      //   this.$refs.file.clearAll();
      //   EventBus.$emit('toast', {type: 'warning', content: `${this.$t('System.uploadTipsType')}`});
      //   return null;
      // }
      // const imgWidth = `${this.$t('System.uploadImgWith')}`;
      // const imgHeight = `${this.$t("System.uploadImgHeight")}`;
      // let tipsWidth = `${this.$t('System.uploadTipsWidth')}`;
      // let tipsHeight= `${this.$t('System.uploadTipsHeight')}`;
      const aud = new Audio();
      aud.src = this.getObjectURL(file.rawFile);
      const That = this;
      console.log("file",file);
      if(file.type != 'mp3' && file.type != 'MP3'){
        this.$refs.file.clearAll();
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('System.uploadSoundTipsType')}`});
        return null;
      }
      That.uploadFile(file);
      document.getElementById("fileSound").value = "";
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    removeImage() {
      document.getElementById("dropArea").style.display = "none";
      const element = document.getElementsByClassName('e-file-remove-btn')[0];
      element.click();
    },
    uploadFile(file){
      // console.log("uploadFile",file);
      this.$layer.confirm({
        msg: `${this.$t('System.uploadConfirm')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.confirm')}`,
          func: () => {
            const url = "/lte/ems/fm/alarmpresent/uploadFile";
            let formData = new FormData();
            formData.append("file", file.rawFile);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            this.axios.post(url, formData, config).then(response => {
              if(response.status == 200 && response.data.errorCode == 'SUCCESS'){
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadSuccess')}`});
                let imgURL = this.getObjectURL(file.rawFile);
                // console.log(file.rawFile.name);
                console.log(response.data.resultVal);
                localStorage.setItem('alarmsound',"/audios/"+response.data.resultVal);
                // if (imgURL) {
                //   document.getElementById("imgShow").src = imgURL;
                // }
                // document.getElementById("dropArea").style.display = "block";
              }else{
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadFault')}`});
              }
            });
          }
        }
      });
    },
    upFile() {
      document
        .getElementsByClassName("e-file-select-wrap")[0]
        .querySelector("button")
        .click();
      return false;
    }
  },
  mounted() {
	  this.queryAlarmLevel();
  }
};
</script>


</style>